import qs from 'qs';

export const getUrlInfo = (url) => {
  const { location } = window;
  let urlObject = location;
  if (url) {
    urlObject = document.createElement('a');
    urlObject.href = url;
  }

  const { href, origin, protocol, host, search, pathname } = urlObject;

  const params = qs.parse(search, {
    ignoreQueryPrefix: true,
  });

  return {
    href,
    origin,
    protocol,
    host,
    params,
    pathname,
  };
};

export const modifyUrlParams = ({ paramsToDelete = [], paramsToAppend = [] }) => {
  const url = new URL(window.location.href);
  const urlParams = new URLSearchParams(url.search.slice(1));
  paramsToDelete.forEach((param) => urlParams.delete(param));
  paramsToAppend.forEach(([name, value]) => urlParams.append(name, value));
  window.history.replaceState(
    {},
    '',
    `${window.location.pathname}?${urlParams}${window.location.hash}`,
  );
};

export const urlParam = ({ param }) => {
  const urlParams = new URLSearchParams(window.location.search);
  if ((urlParams.has(param) && urlParams.get(param) === 'false') || !urlParams.has(param)) {
    return false;
  }
  if (
    (urlParams.has(param) && urlParams.get(param) === 'true') ||
    (urlParams.has(param) && urlParams.get(param) === '')
  ) {
    return true;
  }
  return urlParams.get(param);
};

export const getCurrentStepFromUrl = () => {
  const url = new URL(window.location.href);
  const pathSegments = url.pathname.split('/');
  return pathSegments.find((segment) => segment.startsWith('step-'));
};
